import { useCommentsStore } from '@/modules/comments/comments-store';
import { useNotificationsStore } from '@/modules/notifications/notifications-store';
import { useNotificationPrefsStore } from '@/modules/notifications/notification-prefs-store';
import { useNudgesStore } from '@/modules/nudges/nudges-store';
import { useOperatingStore } from '@/modules/operating/operating-store';
import { useOrgChartStore } from '@/modules/org-chart/org-chart-store';
import { useProcessesStore } from '@/modules/processes/processes-store';
import { useTeamsStore } from '@/modules/teams/teams-store';
import { useWorkspaceStore } from '@/modules/workspaces/workspace-store';

/** Clear state resolved under another Supabase identity before publishing the next one. */
export function resetStateForAccountChange(nextUserId: string | null): boolean {
  const holder = useWorkspaceStore.getState().dataUserId;
  if (!holder || holder === nextUserId) return false;

  useWorkspaceStore.getState().resetForUserChange();
  useTeamsStore.getState().reset();
  useOperatingStore.getState().resetDomain();
  useOperatingStore.getState().resetSessionView();
  useOperatingStore.getState().unsubscribeFromRealtime();
  useOrgChartStore.getState().reset();
  useCommentsStore.getState().reset();
  useProcessesStore.getState().reset();
  useNotificationsStore.getState().unsubscribeFromFollowers();
  useNotificationsStore.getState().reset();
  useNotificationPrefsStore.getState().reset();
  useNudgesStore.getState().reset();
  return true;
}
